<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.5 3C17.328 3 18 3.672 18 4.5V16.5C18 17.328 17.328 18 16.5 18H1.5C0.672 18 0 17.328 0 16.5V4.5C0 3.672 0.672 3 1.5 3H5.25V1.5C5.25 0.672 5.922 0 6.75 0H11.25C12.078 0 12.75 0.672 12.75 1.5V3H16.5ZM16.5 4.875C16.5 4.668 16.332 4.5 16.125 4.5H1.875C1.668 4.5 1.5 4.668 1.5 4.875V16.125C1.5 16.332 1.668 16.5 1.875 16.5H16.125C16.332 16.5 16.5 16.332 16.5 16.125V4.875ZM9.75 9.25H12V10.75H9.75V13H8.25V10.75H6V9.25H8.25V7H9.75V9.25ZM10.875 1.5H7.125C6.918 1.5 6.75 1.668 6.75 1.875V3H11.25V1.875C11.25 1.668 11.082 1.5 10.875 1.5Z"
    [attr.fill]="color"
  />
</svg>
